<script setup lang="ts">
type Props = {
  id?: string;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  initialValue?: string;
  name?: string;
  suffix?: string;
  prefix?: string;
  options?: Form.Options[];
};

const props = defineProps<Props>();

function setSelected(option: string, value: string) {
  if (option === value) return true;

  return false;
}

const modelValue = defineModel<string>('modelValue', {
  default: '',
});

watchEffect(() => (modelValue.value = props.initialValue || ''));
</script>

<template>
  <div class="select-group">
    <span
      v-if="props.prefix"
      class="prefix"
    >
      {{ props.prefix }}
    </span>
    <div
      class="group"
      :class="{
        suffix: props.suffix,
        prefix: props.prefix,
      }"
      :disabled="props.disabled"
      :for="props.id || 'id'"
    >
      <select
        :id="props.id || 'id'"
        v-model="modelValue"
        class="peer select"
        :disabled="props.disabled"
        :name="props.name || ''"
        :readonly="props.readonly"
        :validate-on-blur="true"
        :validate-on-change="true"
      >
        <option
          v-for="item in props.options"
          :key="item.value"
          :selected="setSelected(item.value, modelValue)"
          :value="item.value"
        >
          {{ item.label }}
        </option>
      </select>
    </div>
    <span
      v-if="props.suffix"
      class="sufix"
    >
      {{ props.suffix }}
    </span>
  </div>
</template>

<style scoped lang="postcss">
.select-group {
  @apply flex flex-wrap border-none rounded-lg;
}

.prefix,
.suffix {
  @apply flex justify-center items-center sm:text-sm px-2 text-auth-text-inputs bg-bg-primary/20;
}
.prefix {
  @apply rounded-l-lg;
}
.suffix {
  @apply rounded-r-lg;
}

.group {
  @apply relative block overflow-hidden rounded-lg h-[46px] sm:h-[50px] flex-grow pt-2;
  @apply cursor-text border-0 bg-auth-bg-inputs border-auth-bg-inputs;
}

.group.prefix {
  @apply rounded-l-none;
}
.group.suffix {
  @apply rounded-r-none;
}
.icon {
  @apply !pl-[46px] sm:!pl-[50px];
}
.select {
  @apply h-8 w-full border-none bg-transparent p-0 text-auth-text-inputs focus:border-transparent focus:outline-none focus:ring-0 text-sm px-4;
}
.select option {
  @apply bg-auth-bg-inputs;
}
.select:-webkit-autofill,
.select:-webkit-autofill:hover,
.select:-webkit-autofill:focus {
  -webkit-appearance: none !important;
  -webkit-text-fill-color: #fff !important;
  @apply shadow-input shadow-auth-bg-inputs !important;
}

.icon .label {
  @apply !start-[46px] sm:!start-[50px];
}

.group[disabled]:not([disabled='false']),
.select[disabled]:not([disabled='false']),
.group[disabled]:not([disabled='false']) .label {
  @apply opacity-40 cursor-not-allowed;
}

.required {
  @apply font-bold text-opacity-70 text-sm text-error;
}

@keyframes shake {
  from {
    transform: translateX(-3px);
  }
  to {
    transform: translateX(3px);
  }
}
</style>
